import React from 'react';
import { Box, Typography } from '@mui/material';
import { HappinessQuestion as HappinessQuestionType } from '../../interfaces';
import { HAPPINESS_LABELS } from '../../constants';
import { useStyles } from './styles';
import Smiley from '../../svg/Smiley.svg';
import Smiley1 from '../../svg/Smiley1.svg';
import SmileyAngry from '../../svg/SmileyAngry.svg';
import SmileyMeh from '../../svg/SmileyMeh.svg';
import SmileySad from '../../svg/SmileySad.svg';

interface HappinessQuestionProps {
  question: HappinessQuestionType;
  selectedValue?: number;
  onSelect: (value: number) => void;
}

const HappinessQuestion: React.FC<HappinessQuestionProps> = ({
  question,
  selectedValue,
  onSelect,
}) => {
  const classes = useStyles();

  const smileyIcons = {
    1: SmileyAngry,
    2: SmileySad,
    3: SmileyMeh,
    4: Smiley,
    5: Smiley1,
  };

  const renderHappinessButtons = () => {
    const buttons = [];
    for (let i = 1; i <= 5; i++) {
      const isSelected = selectedValue === i;
      const SmileyIcon = smileyIcons[i as keyof typeof smileyIcons];
      buttons.push(
        <Box
          key={i}
          onClick={() => onSelect(i)}
          sx={{
            ...classes.happinessButton,
            ...(isSelected ? classes.happinessButtonSelected : {}),
          }}
        >
          <Box
            component="img"
            src={SmileyIcon}
            alt={`Smiley ${i}`}
            sx={classes.smileyIcon}
          />
        </Box>,
      );
    }
    return buttons;
  };

  return (
    <Box sx={classes.container}>
      <Box sx={classes.buttonsContainer}>{renderHappinessButtons()}</Box>
      <Box sx={classes.selectedValueContainer}>
        {selectedValue && (
          <Typography sx={classes.selectedValueText}>
            You&apos;ve selected: {HAPPINESS_LABELS[selectedValue]}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default HappinessQuestion;
